import { Typography } from '@mui/material';
import localize from '../../common/localize';

export default function SignOut() {
  return (
    <div
      style={{ marginTop: '10px', marginBottom: '10px' }}
      className="flex w-full items-center justify-center"
    >
      <Typography className="app_text_color">
        {localize.sign_out_message}
      </Typography>
    </div>
  );
}
